import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=605e02a8&scoped=true&lang=html&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=605e02a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e02a8",
  null
  
)

component.options.__file = "Notification.vue"
export default component.exports